<template>
  <div>
    <Header></Header>
    <div class="ui container">
      <div v-if="message != ''" id="message" class="ui icon message ">
        <div class="content">
          <div class="header">{{ message }}</div>
        </div>
      </div>
      <form class="ui form">
        <h4 class="ui dividing header">My Profile</h4>
        <div class="field">
          <label>Username</label>
          <input
            type="text"
            name="profile[user_name]"
            placeholder="Username"
            v-model="profile.user_name"
          />
        </div>
        <div class="field">
          <label>Password</label>
          <input
            type="password"
            name="profile[password]"
            placeholder="Password"
            v-model="profile.password"
          />
        </div>
        <div class="field">
          <label>Confirm Password</label>
          <input
            type="password"
            name="profile[confirmPassword]"
            placeholder="Confirm Password"
            v-model="confirmPassword"
          />
        </div>
        <div class="field">
          <label>First Name</label>
          <input
            type="text"
            name="profile[first-name]"
            placeholder="First Name"
            v-model="profile.first_name"
          />
        </div>
        <div class="field">
          <label>Last Name</label>
          <input
            type="text"
            name="profile[last-name]"
            placeholder="Last Name"
            v-model="profile.last_name"
          />
        </div>
        <div class="field">
          <label>Alias</label>
          <input
            type="text"
            name="profile[alias]"
            placeholder="Alias"
            v-model="profile.user_alias"
          />
        </div>
        <div class="field">
          <label>Email</label>
          <input
            type="text"
            name="profile[Email]"
            placeholder="Email"
            v-model="profile.email_id"
          />
        </div>
        <div class="field">
          <div class="ui toggle checkbox">
            <input
              type="checkbox"
              name="profile[email_not]"
              v-model="profile.email_not"
              true-value="1"
              false-value="0"
            />
            <label>Email Notificacion?</label>
          </div>
        </div>
        <div class="field">
          <label>Gender</label>
          <select
            class="ui dropdown gender"
            name="profile[gender]"
            v-model="profile.gender"
          >
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
        <div class="field">
          <label>Age</label>
          <input
            type="number"
            name="profile[age]"
            min="0"
            v-model="profile.age"
          />
        </div>
        <div class="ui form">
          <div class="inline fields">
            <label>Access Level</label>
            <div class="field">
              <div class="ui radio checkbox">
                <input
                  type="radio"
                  name="profile[access]"
                  v-model="profile.role_id"
                  value="1"
                />
                <label>Admin</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox">
                <input
                  type="radio"
                  name="profile[access]"
                  v-model="profile.role_id"
                  value="2"
                />
                <label>CSR</label>
              </div>
            </div>
            <div class="field">
              <div class="ui radio checkbox">
                <input
                  type="radio"
                  name="profile[access]"
                  v-model="profile.role_id"
                  value="3"
                />
                <label>Manager</label>
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="ui toggle checkbox">
            <input
              type="checkbox"
              name="profile[guidedtour]"
              v-model="profile.guidedtour"
              true-value="1"
              false-value="0"
            />
            <label>Guided Tour?</label>
          </div>
        </div>
        <div class="field">
          <div class="inline fields">
            <label>Assigned Categories?</label>
            <div class="field">
              <div class="ui checkbox">
                <input type="checkbox" name="profile[un-categorized]" />
                <label>Un-categorized</label>
              </div>
            </div>
            <div class="field">
              <div class="ui checkbox">
                <input type="checkbox" name="profile[support]" />
                <label>Support</label>
              </div>
            </div>
          </div>
        </div>
        <router-link class="ui button" to="/">Cancel</router-link>
        <span class="ui button blue" @click="updateProfile">Save</span>
      </form>
    </div>
    <router-view />
  </div>
</template>
<script>
import Header from "../components/Header";
export default {
  name: "profile",
  components: {
    Header
  },
  data() {
    return {
      profile: {
        age: "",
        catgs: [],
        email_id: "",
        email_not: 0,
        first_name: "",
        gender: "",
        guidedtour: "",
        last_name: "",
        num_usr_rating: 0,
        password: "",
        rating: 0.0,
        role_id: 0,
        user_alias: "",
        user_id: 0,
        user_name: ""
      },
      message: "",
      confirmPassword: ""
    };
  },
  methods: {
    updateProfile() {
      if (this.confirmPassword === this.profile.password) {
        this.axios
          .post(this.$store.state.apiUrl + "Update/updateProfile.php", {
            token: localStorage.getItem("token"),
            age: this.profile.age,
            catgs: this.profile.catgs,
            email_id: this.profile.email_id,
            email_not: this.profile.email_not,
            first_name: this.profile.first_name,
            gender: this.profile.gender,
            guidedtour: this.profile.guidedtour,
            last_name: this.profile.last_name,
            num_usr_rating: this.profile.num_usr_rating,
            password: this.profile.password,
            rating: this.profile.rating,
            role_id: this.profile.role_id,
            user_alias: this.profile.user_alias,
            user_id: this.profile.user_id,
            user_name: this.profile.user_name
          })
          .then(res => {
            this.message = "Saved!";
            $("#message").removeClass("warning");
            $("#message").addClass("green");
            $(".message").transition("fade down");
            setTimeout(() => {
              this.showError = false;
              $(".message").transition("fade down");
            }, 5000);
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        $("#message").removeClass("green");
        this.message = "Those passwords didn't match. Try again.";
        $("#message").addClass("warning");
        $(".message").transition("fade down");
        setTimeout(() => {
          this.showError = false;
          $(".message").transition("fade down");
        }, 5000);
      }
    },
    getProfile() {
      this.axios
        .post(this.$store.state.apiUrl + "Read/profile.php", {
          token: localStorage.getItem("token")
        })
        .then(res => {
          this.profile = res.data.data;
          this.confirmPassword = res.data.data.password;
          this.profile.age = res.data.data.age;
          this.profile.catgs = res.data.data.catgs;
          this.profile.email_id = res.data.data.email_id;
          this.profile.email_not = res.data.data.email_not;
          this.profile.first_name = res.data.data.first_name;
          this.profile.guidedtour = res.data.data.guidedtour;
          this.profile.last_name = res.data.data.last_name;
          this.profile.num_usr_rating = res.data.data.num_usr_rating;
          this.profile.password = res.data.data.password;
          this.profile.rating = res.data.data.rating;
          this.profile.role_id = res.data.data.role_id;
          this.profile.user_alias = res.data.data.user_alias;
          this.profile.user_id = res.data.data.user_id;
          this.profile.user_name = res.data.data.user_name;
          $(".ui.dropdown.gender").dropdown(
            "set selected",
            this.profile.gender
          );
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  beforeMount() {
    this.getProfile();
  }
};
</script>
<style>
.warning {
  box-shadow: 0 0 0 1px #c9ba9b inset, 0 0 0 0 transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue